import React from "react";
import { useNavigate } from "react-router-dom";
import { TimeManagementListItem as TimeManagementListItemType } from "@myapp/contract";
import { formatDateDDMMYYYY } from "../../../../shared/helpers/date";
import { ListItem } from "../../../../shared/ui/list/ListIteam/ListItem";
import { timeManagementColumns } from "../model/constants";
import {
  getTimeEntryCategoryLabel,
  TIME_ENTRY_CATEGORY_COLOR,
} from "../../../../entities/time-entry";
import { routes } from "../../../../shared/config/routes";

interface Props {
  item: TimeManagementListItemType;
}

function getTechnicianLabel(item: TimeManagementListItemType): string {
  if (item.technicians.length === 0) return "-";
  if (item.technicians.length === 1) return item.technicians[0].fullName;
  return `${item.technicians.length} Handwerker`;
}

export const TimeManagementListItem: React.FC<Props> = ({ item }) => {
  const navigate = useNavigate();
  const techLabel = getTechnicianLabel(item);
  const techTitle = item.technicians.length > 1
    ? item.technicians.map((t) => t.fullName).join(", ")
    : undefined;

  return (
    <div
      className="cursor-pointer"
      onClick={() => navigate(routes.zeitmanagement.edit(item.id))}
    >
      <ListItem columns={timeManagementColumns}>
        <ListItem.Cell title={techTitle}>{techLabel}</ListItem.Cell>
        <ListItem.Cell className="!flex flex-row items-center gap-2">
          <div
            className="h-3 w-3 rounded-full flex-shrink-0"
            style={{ backgroundColor: TIME_ENTRY_CATEGORY_COLOR }}
          />
          <span>{getTimeEntryCategoryLabel(item.category)}</span>
          {item.needsRescheduling && (
            <span className="ml-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-700">
              {item.reschedulingReason
                ? `Neu planen: ${getTimeEntryCategoryLabel(item.reschedulingReason)}`
                : "Neu planen"
              }
            </span>
          )}
        </ListItem.Cell>
        <ListItem.Cell>{formatDateDDMMYYYY(item.startTime)}</ListItem.Cell>
        <ListItem.Cell>{formatDateDDMMYYYY(item.endTime)}</ListItem.Cell>
      </ListItem>
    </div>
  );
};
